export default __webpack_public_path__ + "static/media/image4-7.a74cafe3.png";